


































































import { Component, Prop, Vue } from "vue-property-decorator";
import { ICategory } from "@/@types/menu/menu/menu";

import BarOrderItem from "../bar-order-item.vue";

@Component({ components: { BarOrderItem } })
export default class BarOrderConstructorCategorys extends Vue {
  @Prop({ type: Array, default: () => [] }) categorys!: Array<ICategory>;
  @Prop({ type: Number, default: 0 }) isActiveCat!: number;
  @Prop({ type: String, default: "" }) category!: string;
}
